<div class="um-shell">
   <!-- Sub-tab nav -->
   <div class="um-sub-tab-nav">
      <div
         class="um-sub-tab-item"
         [class.active]="activeSubTab === 'users'"
         (click)="setSubTab('users')">
         <i class="fa fa-user-group"></i>
         &nbsp; All Users
      </div>
      <div
         class="um-sub-tab-item"
         style="border-right: 0px; padding-right: 13px"
         [class.active]="activeSubTab === 'deferrals'"
         (click)="setSubTab('deferrals')">
         <i class="fa fa-hourglass-half"></i>
         &nbsp; Deferral Requests
         <span
            *ngIf="deferralBadgeCount > 0"
            class="um-badge">
            {{ deferralBadgeCount }}
         </span>
      </div>
   </div>

   <!-- ALL USERS SUB-TAB -->
   <div
      *ngIf="activeSubTab === 'users'"
      class="users-tab-shell"
      [class.panel-open]="!!selectedUser">
      <div
         class="users-table-area"
         [class.openSide]="!!selectedUser">
         <div class="card admin-card">
            <div class="card-head">
               <div
                  class="card-title"
                  style="margin-top: -15px">
                  Performance Hub Users
               </div>
               <div class="admin-actions">
                  <input
                     class="admin-search"
                     [(ngModel)]="userSearch"
                     placeholder="Search by reviewee name or hospital..."
                     (input)="onUserSearch()" />

                  <p-dropdown
                     [(ngModel)]="userCycleFilter"
                     (ngModelChange)="onUserSearch()"
                     [options]="userCycleOptions"
                     placeholder="All cycles"
                     ngModelOptions="{standalone: true}"
                     [showClear]="true"
                     name="userCycleFilter"></p-dropdown>

                  <p-dropdown
                     [(ngModel)]="userHospitalFilter"
                     (ngModelChange)="onUserSearch()"
                     [options]="hospitalOptions"
                     ngModelOptions="{standalone: true}"
                     name="userHospitalFilter"
                     [showClear]="true"
                     placeholder="All hospitals"
                     [filter]="true"
                     class="practice-search"
                     style="min-width: 250px"></p-dropdown>

                  <p-dropdown
                     [(ngModel)]="userDeferredFilter"
                     (ngModelChange)="onUserSearch()"
                     [options]="userDeferredOptions"
                     placeholder="All statuses"
                     ngModelOptions="{standalone: true}"
                     [showClear]="true"
                     name="userDeferredFilter"></p-dropdown>
               </div>
            </div>

            <div
               class="loading"
               *ngIf="usersLoading">
               Loading users…
            </div>

            <div class="admin-tbl-header-wrap">
               <table class="admin-tbl um-users-tbl">
                  <thead>
                     <tr>
                        <th
                           (click)="setUserSort('revieweeDisplayName')"
                           style="cursor: pointer; user-select: none">
                           Reviewee Name
                           <span *ngIf="sortColumn === 'revieweeDisplayName'">{{ sortDir === "asc" ? "↑" : "↓" }}</span>
                        </th>
                        <th
                           (click)="setUserSort('practiceName')"
                           style="cursor: pointer; user-select: none">
                           Hospital
                           <span *ngIf="sortColumn === 'practiceName'">{{ sortDir === "asc" ? "↑" : "↓" }}</span>
                        </th>
                        <th
                           (click)="setUserSort('cycle')"
                           style="cursor: pointer; user-select: none">
                           Cycle
                           <span *ngIf="sortColumn === 'cycle'">{{ sortDir === "asc" ? "↑" : "↓" }}</span>
                        </th>

                        <th
                           (click)="setUserSort('reviewType')"
                           style="cursor: pointer; user-select: none">
                           Review Type
                           <span *ngIf="sortColumn === 'reviewType'">{{ sortDir === "asc" ? "↑" : "↓" }}</span>
                        </th>

                        <th
                           (click)="setUserSort('primaryReviewer')"
                           style="cursor: pointer; user-select: none">
                           Primary Reviewer
                           <span *ngIf="sortColumn === 'primaryReviewer'">{{ sortDir === "asc" ? "↑" : "↓" }}</span>
                        </th>
                        <th
                           (click)="setUserSort('reviewStatus')"
                           style="cursor: pointer; user-select: none">
                           Current Review Progress
                           <span *ngIf="sortColumn === 'reviewStatus'">{{ sortDir === "asc" ? "↑" : "↓" }}</span>
                        </th>
                        <th
                           (click)="setUserSort('isDeferred')"
                           style="cursor: pointer; user-select: none; white-space: nowrap">
                           Deferred
                           <span *ngIf="sortColumn === 'isDeferred'">{{ sortDir === "asc" ? "↑" : "↓" }}</span>
                        </th>
                        <th></th>
                     </tr>
                  </thead>
               </table>
            </div>

            <cdk-virtual-scroll-viewport
               itemSize="62"
               class="admin-tbl-wrap">
               <table class="admin-tbl um-users-tbl">
                  <tbody>
                     <tr
                        *cdkVirtualFor="let u of filteredUsers"
                        [class.selected-row]="selectedUser?.revieweeUserId === u.revieweeUserId"
                        (click)="selectUser(u)"
                        style="cursor: pointer">
                        <td [style.padding]="u.revieweeUserStatus == 'TERMINATED' ? '17px 12px 19px 12px' : '11px 12px'">
                           <div class="name-cell">
                              <div
                                 class="av"
                                 [style.background]="getAvatarBg(u.revieweeDisplayName)"
                                 [style.color]="getAvatarColor(u.revieweeDisplayName)">
                                 {{ getInitials(u.revieweeDisplayName) }}
                              </div>
                              <div>
                                 {{ u.revieweeDisplayName }}
                                 <div
                                    *ngIf="u.revieweeUserStatus == 'TERMINATED'"
                                    class="status-dot">
                                    {{ u.revieweeUserStatus }}
                                 </div>
                              </div>
                           </div>
                        </td>
                        <td>{{ u.practiceName }}</td>

                        <td style="white-space: nowrap">
                           <span
                              *ngIf="getUserCycleDisplay(u)"
                              class="role-chip">
                              {{ getUserCycleDisplay(u) }}
                           </span>
                           <span
                              *ngIf="!getUserCycleDisplay(u)"
                              class="role-chip">
                              TEAM
                           </span>
                        </td>

                        <td style="white-space: nowrap">
                           <span
                              *ngIf="u.reviewType"
                              style="color: #888">
                              {{ u.reviewType }}
                           </span>
                           <span
                              *ngIf="!u.reviewType"
                              style="font-style: italic; color: #b3b3b3; font-weight: 400">
                              UNSET
                           </span>
                        </td>

                        <td>{{ getPrimaryReviewer(u).join(" / ") }}</td>

                        <td style="white-space: nowrap">
                           <span
                              *ngIf="getRowReviewStatus(u) as status"
                              class="defer-status-badge"
                              [ngClass]="status.badge">
                              {{ status.label }}
                           </span>
                        </td>

                        <td>
                           @if (isActivelyDeferred(u)) {
                              <span style="color: #f7682a; font-size: 18px"><i class="fa fa-clock"></i></span>
                           } @else {
                              <span style="color: #888">---</span>
                           }
                        </td>

                        <td style="text-align: right; padding-right: 20px">
                           <a (click)="selectUser(u); $event.stopPropagation()">
                              <i
                                 class="fa fa-pen-to-square"
                                 style="color: #9a9ca0"></i>
                           </a>
                        </td>
                     </tr>
                     <tr *ngIf="filteredUsers.length === 0 && !usersLoading">
                        <td
                           colspan="8"
                           class="muted"
                           style="padding: 20px; text-align: center">
                           No users found.
                        </td>
                     </tr>
                  </tbody>
               </table>
            </cdk-virtual-scroll-viewport>
         </div>
      </div>

      <!-- Slide-in edit panel -->
      <div
         class="edit-slide-panel"
         [class.open]="!!selectedUser">
         <div class="slide-panel-header">
            <div
               class="name-cell"
               *ngIf="selectedUser">
               <div
                  class="av av-lg"
                  [style.background]="getAvatarBg(selectedUser.revieweeDisplayName)"
                  [style.color]="getAvatarColor(selectedUser.revieweeDisplayName)">
                  {{ getInitials(selectedUser.revieweeDisplayName) }}
               </div>
               <div>
                  <div class="selected-user-name">{{ selectedUser.revieweeDisplayName }}</div>
                  <div class="selected-user-meta">{{ selectedUser.practiceName }}</div>
                  <!--<div
                     class="selected-user-meta"
                     style="color: #5b5b5b; font-size: 11px; letter-spacing: 1px; font-weight: 400; font-style: italic">
                     REVIEWEE
                     <span *ngIf="selectedUser.jobTitleCode">· {{ selectedUser.jobTitleCode }}</span>
                  </div>-->
               </div>
            </div>

            <div
               class="defer-status-badge"
               style="margin-left: auto; margin-right: 4px; min-width: 80px; text-align: center"
               *ngIf="selectedUser"
               [ngClass]="isActivelyDeferred(selectedUser) ? 'badge-deferred' : 'badge-active'">
               <i
                  class="fa"
                  [class.fa-clock]="isActivelyDeferred(selectedUser)"
                  [class.fa-circle-check]="!isActivelyDeferred(selectedUser)"></i>
               {{ isActivelyDeferred(selectedUser) ? "Deferred" : "Active" }}
            </div>

            <button
               class="close-btn"
               title="Close"
               (click)="closeUserEdit()">
               ✕
            </button>
         </div>

         <!-- Side panel tabs -->
         <div
            class="um-panel-tabs"
            *ngIf="selectedUser">
            <button
               type="button"
               *ngFor="let t of panelTabs"
               class="um-panel-tab"
               [class.active]="panelTab === t.id"
               (click)="setPanelTab(t.id)">
               {{ t.label }}
               <span
                  *ngIf="t.id === 'history' && userHistory.length"
                  class="um-panel-tab-count">
                  {{ userHistory.length }}
               </span>
            </button>
         </div>

         <div
            class="slide-panel-body"
            *ngIf="selectedUser">
            <!-- OVERVIEW TAB -->
            <ng-container *ngIf="panelTab === 'overview'">
               <!-- Employment -->
               <div class="card admin-card slide-card">
                  <div
                     class="card-head"
                     style="margin-bottom: 16px">
                     <div
                        class="card-title"
                        style="font-size: 16px">
                        Employment
                     </div>
                  </div>

                  <div class="um-info-grid">
                     <div>
                        <div class="reviewers-section-label">STATUS</div>
                        <div
                           class="um-info-value"
                           [style.color]="getEmploymentStatus(selectedUser) == 'Terminated' ? '#cd1402' : '#353737'">
                           {{ getEmploymentStatus(selectedUser) == "Terminated" ? "TERMINATED" : getEmploymentStatus(selectedUser) }}
                        </div>
                     </div>
                     <div>
                        <div class="reviewers-section-label">HIRE DATE</div>
                        <div class="um-info-value">
                           {{ formatHireDate(selectedUser.hireDate) }}
                        </div>
                     </div>
                     <div>
                        <div class="reviewers-section-label">REVIEW TYPE</div>
                        <div class="um-info-value">
                           <span *ngIf="selectedUser.reviewType">{{ selectedUser.reviewType }}</span>
                           <span
                              *ngIf="!selectedUser.reviewType"
                              style="font-style: italic; color: #b3b3b3; font-weight: 400">
                              UNSET
                           </span>
                        </div>
                     </div>
                     <div>
                        <div class="reviewers-section-label">JOB CODE / ROLE</div>
                        <div class="um-info-value">{{ selectedUser.jobTitleCode || "—" }}</div>
                     </div>
                     <div>
                        <div class="reviewers-section-label">CYCLE</div>
                        <div class="um-info-value">
                           <span
                              class="role-chip"
                              style="margin-left: -2px">
                              {{ getUserCycleDisplay(selectedUser) || "TEAM" }}
                           </span>
                           <span
                              *ngIf="getUserCycleDisplay(selectedUser) === 'OPEN' && selectedUser.whenOpenCompletedBy"
                              class="um-info-sub">
                              Complete by {{ selectedUser.whenOpenCompletedBy }}
                           </span>
                        </div>
                     </div>
                     <div>
                        <div class="reviewers-section-label">HUB ROLE</div>
                        <div class="um-info-value">
                           Reviewee
                           <span
                              *ngIf="primaryReviewerForCount"
                              class="um-info-sub"
                              style="margin-top: 0px">
                              Primary reviewer for {{ primaryReviewerForCount }}
                           </span>
                        </div>
                     </div>
                  </div>
               </div>

               <!-- Current review progress -->
               <div class="card admin-card slide-card">
                  <div
                     class="card-head"
                     style="margin-bottom: 16px">
                     <div
                        class="card-title"
                        style="font-size: 16px">
                        Current Review Progress
                     </div>
                     <div
                        *ngIf="!reviewProgressLoading"
                        class="defer-status-badge"
                        [ngClass]="currentReviewStatus.badge">
                        {{ currentReviewStatus.label }}
                     </div>
                  </div>

                  <div
                     class="muted um-history-empty"
                     *ngIf="reviewProgressLoading">
                     Loading review progress…
                  </div>

                  <ng-container *ngIf="!reviewProgressLoading">
                     <div
                        class="um-progress-step"
                        *ngFor="let step of reviewSteps"
                        [class.done]="step.done">
                        <span class="um-progress-dot">
                           <i
                              *ngIf="step.done"
                              class="fa fa-check"></i>
                        </span>
                        <div>
                           <div class="um-progress-label">{{ step.label }}</div>
                           <div
                              *ngIf="step.sub"
                              class="um-progress-sub">
                              {{ step.sub }}
                           </div>
                        </div>
                     </div>
                  </ng-container>
               </div>

               <!-- Recent changes -->
               <div class="card admin-card slide-card">
                  <div
                     class="card-head"
                     style="margin-bottom: 8px">
                     <div
                        class="card-title"
                        style="font-size: 16px">
                        Recent Changes
                     </div>
                     <a
                        *ngIf="userHistory.length > recentHistory.length"
                        class="change-btn"
                        style="color: #057262; text-decoration: none; padding-top: 5px; padding-right: 0px"
                        href="javascript:void(0);"
                        (click)="setPanelTab('history')">
                        See full history →
                     </a>
                  </div>
                  <ng-container *ngTemplateOutlet="historyList; context: { $implicit: recentHistory }"></ng-container>
               </div>

               <!-- Past reviews -->
               <div
                  class="card admin-card slide-card"
                  *ngIf="pastReviews.length">
                  <div
                     class="card-head"
                     style="margin-bottom: 8px">
                     <div
                        class="card-title"
                        style="font-size: 16px">
                        Past Reviews
                     </div>
                  </div>
                  <div
                     class="um-history-item"
                     *ngFor="let r of pastReviews">
                     <div class="um-history-body">
                        <div
                           class="um-history-title"
                           style="margin-top: 0">
                           {{ r.cycle ? r.cycle + " · " : "" }}{{ r.reviewType }}
                        </div>
                        <div class="um-history-meta">Completed {{ formatShortDate(r.completedOn) || "—" }}</div>
                     </div>
                  </div>
               </div>
            </ng-container>

            <!-- REVIEWERS TAB -->
            <ng-container *ngIf="panelTab === 'reviewers'">
               <!-- Reviewer management card -->
               <div class="card admin-card slide-card">
                  <div
                     class="card-head"
                     style="margin-bottom: 16px">
                     <div
                        class="card-title"
                        style="font-size: 16px">
                        Reviewer Management
                     </div>
                  </div>

                  <div class="reviewers-section-label">PRIMARY REVIEWER</div>

                  <div
                     class="reviewer-list"
                     *ngFor="let pr of getPrimaryReviewer(selectedUser); let i = index">
                     <div class="reviewer-row">
                        <div
                           class="reviewer-role-label reviewer-role-label--top"
                           [style.align-self]="
                              getOverrideName(getPrimaryReviewerRole(selectedUser, i)) &&
                              pr != getOverrideName(getPrimaryReviewerRole(selectedUser, i))
                                 ? 'baseline'
                                 : 'center'
                           ">
                           {{ getPrimaryReviewerRole(selectedUser, i) }}
                        </div>

                        <div class="reviewer-info">
                           <div class="reviewer-info-top">
                              <div class="reviewer-name">{{ pr || "—" }}</div>

                              <span
                                 *ngIf="
                                    getOverrideName(getPrimaryReviewerRole(selectedUser, i)) &&
                                    pr != getOverrideName(getPrimaryReviewerRole(selectedUser, i))
                                 "
                                 class="reviewer-overridden-badge">
                                 OVERRIDDEN
                              </span>

                              <button
                                 class="change-btn reviewer-edit-btn"
                                 (click)="openReviewerModal(getPrimaryReviewerRole(selectedUser, i), true)">
                                 <i class="fa fa-pencil"></i>
                              </button>
                           </div>

                           <div
                              class="reviewer-revert-row"
                              *ngIf="
                                 getOverrideName(getPrimaryReviewerRole(selectedUser, i)) &&
                                 pr != getOverrideName(getPrimaryReviewerRole(selectedUser, i))
                              ">
                              <span class="reviewer-revert-text">
                                 Revert back to system name:
                                 {{ getOverrideName(getPrimaryReviewerRole(selectedUser, i)) }}
                              </span>

                              <a
                                 href="javascript:void(0);"
                                 class="reviewer-revert-link"
                                 (click)="
                                    removeAssignmentOverride(
                                       getPrimaryReviewerRole(selectedUser, i),
                                       getOverrideName(getPrimaryReviewerRole(selectedUser, i))
                                    )
                                 ">
                                 <i class="fa fa-undo">&nbsp;</i>
                                 <span>Revert</span>
                              </a>
                           </div>
                        </div>
                     </div>

                     <div
                        class="reviewer-row"
                        *ngIf="getPrimaryReviewerRole(selectedUser, i) == 'HM' && selectedUser?.hmDisplayName2">
                        <div
                           class="reviewer-role-label reviewer-role-label--top"
                           style="align-self: center">
                           HM
                        </div>
                        <div class="reviewer-info">
                           <div class="reviewer-name">{{ selectedUser?.hmDisplayName2 }}</div>
                        </div>
                     </div>

                     <div
                        class="reviewer-row"
                        *ngIf="
                           getPrimaryReviewer(selectedUser)?.length === 1 &&
                           getPrimaryReviewerRole(selectedUser, i) == 'HM' &&
                           !selectedUser?.hmDisplayName2
                        ">
                        <button
                           class="change-btn"
                           style="text-decoration: none"
                           (click)="addingAddtionalHM = true; openReviewerModal(getPrimaryReviewerLabel(selectedUser), true)">
                           <i class="fa fa-add"></i>
                           &nbsp;Add Additional HM
                        </button>
                     </div>
                  </div>

                  <div
                     class="reviewer-list"
                     *ngIf="getPrimaryReviewer(selectedUser)?.length === 0">
                     <div class="reviewer-row">
                        <button
                           class="change-btn"
                           style="text-decoration: none"
                           (click)="addingAddtionalHM = false; openReviewerModal(getPrimaryReviewerLabel(selectedUser), true)">
                           <i class="fa fa-add"></i>
                           &nbsp;Add Reviewer
                        </button>
                     </div>
                  </div>

                  <div
                     class="reviewers-section-label"
                     style="margin-top: 20px">
                     REVIEWERS
                  </div>
                  <div class="reviewer-list">
                     <div
                        class="reviewer-row"
                        *ngFor="let row of getReviewerRows(selectedUser)">
                        <div
                           class="reviewer-role-label reviewer-role-label--top"
                           [style.align-self]="row.overrideName && row.name != row.overrideName ? 'baseline !important' : 'center'">
                           {{ row.role }}
                        </div>

                        <div class="reviewer-info">
                           <div class="reviewer-info-top">
                              <div class="reviewer-name">{{ row.name || "—" }}</div>

                              <span
                                 *ngIf="row.overrideName && row.name != row.overrideName"
                                 class="reviewer-overridden-badge">
                                 OVERRIDDEN
                              </span>

                              <button
                                 class="change-btn reviewer-edit-btn"
                                 (click)="addingAddtionalHM = false; openReviewerModal(row.role, false)">
                                 <i class="fa fa-pencil"></i>
                              </button>
                           </div>

                           <div
                              class="reviewer-revert-row"
                              *ngIf="row.overrideName && row.name != row.overrideName">
                              <span class="reviewer-revert-text">Revert back to system name: {{ row.overrideName }}</span>
                              <a
                                 href="javascript:void(0);"
                                 class="reviewer-revert-link"
                                 (click)="removeAssignmentOverride(row.role, row.overrideName)">
                                 <i class="fa fa-undo">&nbsp;</i>
                                 <span>Revert</span>
                              </a>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div
                     class="admin-success"
                     *ngIf="reviewerSuccess">
                     {{ reviewerSuccess }}
                  </div>
                  <div
                     class="admin-error"
                     *ngIf="reviewerError">
                     {{ reviewerError }}
                  </div>

                  <div
                     class="reviewer-change-form"
                     style="flex-direction: column; align-items: stretch"
                     *ngIf="editingReviewerRole">
                     <div style="display: flex; align-items: center; gap: 10px">
                        <div class="reviewer-change-label">{{ addingAddtionalHM ? "Adding" : "Changing" }} {{ editingReviewerRole }}:</div>
                        <p-dropdown
                           [style]="{ width: '100%' }"
                           [options]="reviewerCandidates"
                           [(ngModel)]="editingReviewerUserId"
                           optionLabel="displayName"
                           optionValue="id"
                           [filter]="true"
                           filterBy="displayName"
                           placeholder="Select a reviewer…"
                           ngModelOptions="{standalone: true}"
                           name="editingReviewerUserId"></p-dropdown>
                     </div>
                     <div style="display: flex">
                        <textarea
                           class="defer-textarea-input"
                           [(ngModel)]="rcReasonInput"
                           [placeholder]="addingAddtionalHM ? 'Why are you adding this HM?' : 'Why are you making this change?'"
                           [rows]="4"></textarea>
                     </div>
                     <div style="width: 100%; display: flex; gap: 10px; align-self: self-end">
                        <div class="change-reviewer-box">
                           <label class="change-reviewer-box-label">
                              <input
                                 type="checkbox"
                                 [(ngModel)]="makeChangeForHospital" />
                              {{ addingAddtionalHM ? "Add HM for the entire hospital" : "Make change for the entire hospital" }}
                           </label>
                        </div>
                        <button
                           class="v-button v-button-md v-gray"
                           style="margin-left: auto; max-height: 40px"
                           (click)="addingAddtionalHM = false; editingReviewerRole = null">
                           Cancel
                        </button>
                        <button
                           class="v-button v-button-md v-teal"
                           style="max-height: 40px"
                           [disabled]="!editingReviewerUserId"
                           (click)="confirmReviewerChange()">
                           Confirm
                        </button>
                     </div>
                  </div>
               </div>

               <ng-container *ngTemplateOutlet="historyCard; context: { title: 'Reviewer History', entries: reviewerHistory }"></ng-container>
            </ng-container>

            <!-- CYCLE TAB -->
            <ng-container *ngIf="panelTab === 'cycle'">
               <div class="slide-panel-bottom-row">
                  <!-- Cycle management card (VET only) -->
                  <!--<div
                     class="card admin-card slide-card"
                     style="width: 50%"
                     *ngIf="selectedUser?.jobTitleCode === 'VET'">-->
                  <div class="card admin-card slide-card">
                     <div
                        class="card-head"
                        style="margin-bottom: 16px">
                        <div
                           class="card-title"
                           style="font-size: 16px">
                           Review Cycle
                        </div>
                     </div>

                     <span *ngIf="assignedCycleOpen">
                        <p class="defer-prompt">Assigned Cycle</p>
                        <select
                           class="defer-select"
                           [(ngModel)]="editingDvmCycle"
                           (ngModelChange)="
                              editingReviewType =
                                 $event === 'TEAM' || $event === 'OPEN'
                                    ? ['CLINICAL', 'CROSSTRAINED', 'RECEPTION'].includes(selectedUser?.reviewType ?? '')
                                       ? selectedUser.reviewType
                                       : ''
                                    : editingReviewType
                           ">
                           <option
                              value=""
                              disabled
                              hidden>
                              {{ usersLoading ? "Loading..." : "Select a cycle" }}
                           </option>
                           <option value="Q1">aDVM Q1</option>
                           <option value="Q2">aDVM Q2</option>
                           <option value="Q3">aDVM Q3</option>
                           <option value="Q4">aDVM Q4</option>
                           <option value="HM">HM</option>
                           <option value="COS">COS</option>
                           <option value="RM">RM</option>
                           <option value="DO">DO</option>
                           <option value="OPEN">OPEN</option>
                           <option value="TEAM">TEAM</option>
                        </select>

                        <p
                           class="defer-prompt"
                           style="margin-top: 18px"
                           *ngIf="
                              (editingDvmCycle == 'TEAM' || editingDvmCycle == 'OPEN') &&
                              (selectedUser?.reviewType == 'CLINICAL' ||
                                 selectedUser?.reviewType == 'RECEPTION' ||
                                 selectedUser?.reviewType == 'CROSSTRAINED')
                           ">
                           Review Type
                        </p>
                        <div
                           *ngIf="
                              (editingDvmCycle == 'TEAM' || editingDvmCycle == 'OPEN') &&
                              (selectedUser?.reviewType == 'CLINICAL' ||
                                 selectedUser?.reviewType == 'RECEPTION' ||
                                 selectedUser?.reviewType == 'CROSSTRAINED')
                           ">
                           <select
                              class="defer-select"
                              [(ngModel)]="editingReviewType">
                              <option
                                 value=""
                                 disabled
                                 hidden>
                                 {{ usersLoading ? "Loading..." : "Select a review type" }}
                              </option>
                              <option value="CLINICAL">Clinical</option>
                              <option value="CROSSTRAINED">Cross-Trained</option>
                              <option value="RECEPTION">Reception</option>
                           </select>
                        </div>

                        <p
                           class="defer-prompt"
                           style="margin-top: 18px"
                           *ngIf="editingDvmCycle == 'OPEN'">
                           When Should This Review be Completed?
                        </p>
                        <div
                           *ngIf="editingDvmCycle == 'OPEN'"
                           class="defer-quarter-strip">
                           <div
                              class="defer-quarter-option"
                              [class.selected]="!deferQuarter"
                              (click)="selectDeferQuarter(null)">
                              <div class="defer-quarter-label">Unsure</div>
                           </div>
                           <div
                              *ngFor="let q of deferQuarterOptions"
                              class="defer-quarter-option"
                              [class.selected]="deferQuarter === q.value"
                              (click)="selectDeferQuarter(q.value)">
                              <div class="defer-quarter-label">{{ q.label }} {{ q.sub }}</div>
                           </div>
                        </div>

                        <p
                           class="defer-prompt"
                           style="margin-top: 18px">
                           Additional Details
                        </p>

                        <textarea
                           class="defer-textarea-input"
                           [(ngModel)]="cycleChangeReason"
                           placeholder="Enter reason for cycle change"
                           rows="4"></textarea>

                        <label
                           class="change-reviewer-box-label"
                           *ngIf="
                              editingDvmCycle == 'OPEN' &&
                              (selectedUser?.reviewType == 'CLINICAL' ||
                                 selectedUser?.reviewType == 'RECEPTION' ||
                                 selectedUser?.reviewType == 'CROSSTRAINED')
                           "
                           style="margin-top: 0px">
                           <input
                              type="checkbox"
                              [(ngModel)]="makeCycleChangeForHospital" />
                           <div style="margin-top: 16px; margin-bottom: 6px">
                              Move entire hospital to OPEN cycle
                              <br />
                              <div style="color: #888; font-style: italic; font-weight: 400">
                                 (only for Team Members whose reviews are incomplete)
                              </div>
                           </div>
                        </label>

                        <button
                           class="v-button v-button-md v-teal"
                           style="width: 100%; margin-top: 10px"
                           [disabled]="dvmCycleSaving || editingDvmCycle === selectedUser?.reviewType"
                           (click)="saveDvmCycle()">
                           {{ dvmCycleSaving ? "Saving…" : "Save" }}
                        </button>

                        <div
                           class="admin-success"
                           *ngIf="dvmCycleSuccess">
                           {{ dvmCycleSuccess }}
                        </div>
                        <div
                           class="admin-error"
                           *ngIf="dvmCycleError">
                           {{ dvmCycleError }}
                        </div>
                     </span>
                  </div>
               </div>

               <ng-container *ngTemplateOutlet="historyCard; context: { title: 'Cycle History', entries: cycleHistory }"></ng-container>
            </ng-container>

            <!-- DEFERRAL TAB -->
            <ng-container *ngIf="panelTab === 'deferral'">
               <div class="slide-panel-bottom-row">
                  <!-- Request Deferral -->
                  <div
                     class="card admin-card defer-card slide-card"
                     style="padding-bottom: 30px">
                     <div
                        class="card-head"
                        style="margin-bottom: 16px">
                        <div
                           class="card-title"
                           style="font-size: 16px">
                           {{ isActivelyDeferred(selectedUser) ? "User Deferred" : "Defer User" }}
                        </div>
                     </div>

                     <span *ngIf="deferUserOpen">
                        <!-- Current reason (deferred only) -->
                        <div
                           *ngIf="isActivelyDeferred(selectedUser)"
                           class="defer-current-reason">
                           <div
                              class="reviewers-section-label"
                              style="margin-top: 0px; margin-bottom: 2px">
                              CURRENT REASON
                           </div>
                           <div class="defer-reason-text">
                              {{ selectedUser?.deferReason || "—" }}
                           </div>
                        </div>

                        <!-- Re-enable button (deferred only) -->
                        <button
                           *ngIf="isActivelyDeferred(selectedUser)"
                           class="v-button v-button-md v-orange-outline defer-reenable-btn"
                           [disabled]="deferSaving"
                           (click)="reEnableUser()"
                           style="width: 100%; margin-bottom: 16px">
                           {{ deferSaving ? "Saving…" : "Re-enable user" }}
                        </button>

                        <!-- Divider (deferred only) -->
                        <div
                           *ngIf="isActivelyDeferred(selectedUser)"
                           class="defer-divider"></div>

                        <p class="defer-prompt">Reason Category</p>

                        <select
                           class="defer-select"
                           [(ngModel)]="deferReasonCategory">
                           <option
                              value=""
                              disabled
                              hidden>
                              {{ usersLoading ? "Loading..." : "Select a reason" }}
                           </option>
                           <option value="Newly hired employee">Newly hired employee</option>
                           <option value="Recently completed review or promotion">Recently completed review or promotion</option>
                           <option value="Extended leave of absence">Extended leave of absence</option>
                           <option value="Insufficient time under current manager">Insufficient time under current manager</option>
                           <option value="Performance improvement or corrective action process already in progress">
                              Performance improvement or corrective action process already in progress
                           </option>
                           <option value="Separation from the organization">Separation from the organization</option>
                           <option value="Relief or Seasonal">Relief or Seasonal</option>
                           <option value="Other">Other</option>
                        </select>

                        <p
                           class="defer-prompt"
                           style="margin-top: 18px">
                           Additional Details
                        </p>

                        <textarea
                           class="defer-textarea-input"
                           [(ngModel)]="deferReasonInput"
                           [placeholder]="isActivelyDeferred(selectedUser) ? 'Enter new reason for deferral…' : 'Enter reason for deferral…'"
                           [rows]="isActivelyDeferred(selectedUser) ? 3 : 4"></textarea>

                        @if (isActivelyDeferred(selectedUser)) {
                           <button
                              class="change-btn"
                              style="width: 100%; margin-top: 4px; font-size: 10px; text-align: left; padding: 0px"
                              [disabled]="deferSaving || !deferReasonInput?.trim()"
                              (click)="deferUser()">
                              {{ deferSaving ? "Saving…" : "Update Reason" }}
                           </button>
                        } @else {
                           <button
                              class="v-button v-button-md v-teal"
                              style="width: 100%; margin-top: 10px"
                              [disabled]="deferSaving || !deferReasonInput?.trim()"
                              (click)="deferUser()">
                              {{ deferSaving ? "Saving…" : "Defer user" }}
                           </button>
                        }

                        <div
                           class="admin-success"
                           *ngIf="deferSuccess">
                           {{ deferSuccess }}
                        </div>
                        <div
                           class="admin-error"
                           *ngIf="deferError">
                           {{ deferError }}
                        </div>
                     </span>
                  </div>
               </div>

               <ng-container *ngTemplateOutlet="historyCard; context: { title: 'Deferral History', entries: deferralHistory }"></ng-container>
            </ng-container>

            <!-- HISTORY TAB -->
            <ng-container *ngIf="panelTab === 'history'">
               <ng-container *ngTemplateOutlet="historyCard; context: { title: '', entries: userHistory }"></ng-container>
            </ng-container>
         </div>
      </div>
   </div>

   <!-- DEFERRAL REQUESTS SUB-TAB -->
   <div *ngIf="activeSubTab === 'deferrals'">
      <app-deferral-requests
         [currentAdminName]="currentAdminName"
         [pendingDeferralId]="pendingDeferralId"
         (deferralCountChange)="onDeferralCountChange($event)"></app-deferral-requests>
   </div>

   <ng-template
      #historyCard
      let-title="title"
      let-entries="entries">
      <div class="card admin-card slide-card">
         <div
            *ngIf="title"
            class="card-head"
            style="margin-bottom: 8px">
            <div
               class="card-title"
               style="font-size: 16px">
               {{ title }}
            </div>
         </div>
         <ng-container *ngTemplateOutlet="historyList; context: { $implicit: entries }"></ng-container>
      </div>
   </ng-template>

   <ng-template
      #historyList
      let-entries>
      <div
         class="muted um-history-empty"
         *ngIf="!entries?.length">
         {{ userHistoryLoading ? "Loading history…" : "No changes recorded yet." }}
      </div>
      <div
         class="um-history-item"
         *ngFor="let h of entries">
         <span
            class="audit-badge"
            style="margin-left: -2px; align-self: start; min-width: 70px; text-align: center"
            [ngClass]="h.badgeClass">
            {{ h.label }}
         </span>
         <!--<div class="um-history-date">
            <div class="um-history-day">{{ formatHistoryDay(h.timestamp) }}</div>
            {{ formatHistoryTime(h.timestamp) }}
         </div>-->
         <div class="um-history-body">
            <div class="um-history-title">{{ h.title }}</div>
            <div class="um-history-meta">
               {{ formatHistoryDay(h.timestamp) }} · {{ h.who }}
               <ng-container *ngIf="h.scope">· {{ h.scope }}</ng-container>
            </div>
            <div
               *ngIf="h.reason"
               class="um-history-reason">
               “{{ h.reason }}”
            </div>
         </div>
      </div>
   </ng-template>
</div>
